<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.cancel_wizard") }}
        </v-card-title>
        <v-card-text>
          {{
            $t(
              "views.billingwizard.if_you_exit_the_wizard_any_changes_made_so_far"
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialog = false">
            {{ $t("globals.keep_working") }}
          </v-btn>
          <v-btn color="primary" @click="cancel()">
            {{ $t("globals.cancel_anyway") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="with-margin" v-if="term !== null">
      <material-card
        :title="
          $t('views.revisewizard.premiums_&_billing_calculation_for_{0}_term', [
            trans(term, 'Name'),
          ]) +
            ' (' +
            term.StartDate.split('T')[0].replace(/-/g, '/') +
            ' - ' +
            term.EndDate.split('T')[0].replace(/-/g, '/') +
            ')'
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="assistant"
      >
        <v-card-text>
          {{
            $t(
              "views.revisewizard.you_are_few_steps_away_from_revising_calculation_premiums_&_billing_{0}",
              [[trans(selectedPlan, "Name")]]
            )
          }}
        </v-card-text>
        <v-stepper v-model="step" vertical>
          <v-stepper-step
            :complete="step > 1"
            step="1"
            v-if="planParameters.HasStores && planParameters.ReportsPerStore"
          >
            {{ $t("views.revisewizard.select_store") }}
            <small>
              {{
                $t(
                  "views.revisewizard.select_the_store_for_the_revised_calculation"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content
            step="1"
            v-if="planParameters.HasStores && planParameters.ReportsPerStore"
          >
            <v-card>
              <v-card-text>
                <v-form v-model="storeValid">
                  <v-container fluid>
                    <v-row>
                      <v-col sm="4" v-if="!planParameters.HasBillingImport">
                        <v-select
                          :items="stores"
                          v-model="selectedStores"
                          :label="$t('views.revisewizard.select_store')"
                          item-text="Name"
                          item-value="Id"
                          :rules="[$rules.required]"
                          return-object
                          multiple
                          class="required"
                        ></v-select>
                      </v-col>
                      <v-col sm="4" v-else>
                        <v-select
                          :items="storeTypes"
                          v-model="storeType"
                          :label="$t('views.revisewizard.select_store_type')"
                          :rules="[$rules.required]"
                          item-text="Name"
                          item-value="Id"
                          return-object
                          class="required"
                        ></v-select>
                      </v-col>
                      <v-col
                        sm="4"
                        v-if="
                          storeType &&
                            (storeType.Id === 1 || storeType.Id === 2)
                        "
                      >
                        <v-select
                          :items="stores"
                          v-model="selectedStores"
                          :label="$t('views.revisewizard.select_store')"
                          item-text="Name"
                          item-value="Id"
                          :rules="[$rules.required]"
                          return-object
                          multiple
                          class="required"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-flex>
                  <v-btn text @click="dialog = true">
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn
                    :loading="loading"
                    :disabled="!storeValid"
                    color="primary"
                    @click="
                      storeType && storeType.Id === 1 ? (step = 5) : (step = 2)
                    "
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step
            :complete="
              planParameters.HasStores && planParameters.ReportsPerStore
                ? step > 2
                : step > 1
            "
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 2 : 1
            "
          >
            {{ $t("views.billingwizard.update_members") }}
            <small>
              {{
                $t(
                  "views.billingwizard.edit_the_members_information_if_required_for_the_calculation"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 2 : 1
            "
          >
            <v-card>
              <members-management-table
                ref="membersTable"
                :expandable="false"
                @setMembers="members = true"
                :identifier="selectedPlan.Id + '_membersTable_revise'"
                :term="term"
              ></members-management-table>
              <v-card-actions>
                <v-flex>
                  <v-btn text @click="dialog = true">
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      planParameters.HasStores && planParameters.ReportsPerStore
                    "
                    text
                    @click="step = 1"
                  >
                    {{ $t("globals.back") }}
                  </v-btn>
                  <v-btn
                    :loading="loading"
                    :disabled="!members"
                    color="primary"
                    @click="
                      planParameters.HasStores && planParameters.ReportsPerStore
                        ? (step = 3)
                        : (step = 2)
                    "
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step
            :complete="
              planParameters.HasStores && planParameters.ReportsPerStore
                ? step > 3
                : step > 2
            "
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 3 : 2
            "
          >
            {{
              $t(
                "views.billingwizard.review_and_verify_members_data_for_calculation"
              )
            }}
            <small>
              {{
                $t(
                  "views.billingwizard.the_table_below_presents_the_members_data_that_will_be"
                )
              }}
            </small>
          </v-stepper-step>

          <v-stepper-content
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 3 : 2
            "
          >
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col>
                    <v-banner
                      v-if="!membersForTerm && loaded"
                      color="error"
                      icon="error_outline"
                      elevation="0"
                      icon-color="white"
                    >
                      {{
                        $t(
                          "views.billingwizard.no_active_members_found_for_this_billing_period"
                        )
                      }}
                    </v-banner>
                  </v-col>
                </v-row>
              </v-container>
              <material-card
                :title="$t('views.billingwizard.members_for_calculation')"
                :color="$vuetify.theme.themes.light.secondary"
                icon="folder_special"
                v-if="
                  membersForTermHeaders !== null &&
                    membersForTermHeaders !== undefined
                "
              >
                <pbas-data-table
                  :exporters="$exporters"
                  v-if="$refs.membersTable"
                  ref="membersForTermTable"
                  :dataProvider="membersProvider"
                  fileNamePrefix="term-members"
                  @itemsChanged="setMembersForTerm($event)"
                  :identifier="selectedPlan.Id + '_membersForTermTable'"
                  @error="error = $event"
                ></pbas-data-table>
              </material-card>
              <v-card-actions>
                <v-flex>
                  <v-btn text @click="dialog = true">
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn
                    text
                    @click="
                      planParameters.HasStores && planParameters.ReportsPerStore
                        ? (step = 2)
                        : (step = 1)
                    "
                  >
                    {{ $t("globals.back") }}
                  </v-btn>
                  <v-btn
                    :disabled="!membersForTerm"
                    color="primary"
                    @click="
                      planParameters.HasStores && planParameters.ReportsPerStore
                        ? (step = 4)
                        : (step = 3)
                    "
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step
            :complete="
              planParameters.HasStores && planParameters.ReportsPerStore
                ? step > 4
                : step > 3
            "
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 4 : 3
            "
          >
            {{ $t("views.revisewizard.perform_calculation") }}
            <small>
              {{ $t("views.revisewizard.press_continue_to_proceed_with") }}
            </small>
          </v-stepper-step>

          <v-stepper-content
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 4 : 3
            "
          >
            <v-card>
              <div v-if="calculateMessage !== ''">
                <v-banner
                  :icon="calculateIcon"
                  :color="calculateColor"
                  elevation="0"
                  icon-color="white"
                >
                  {{ $t(calculateMessage) }}
                </v-banner>
              </div>
              <v-container v-if="calculateColor != 'success'">
                <v-row>
                  <v-banner icon elevation="0" icon-color="white">
                    <span>
                      {{ $t("views.revisewizard.no_adjustments") }}
                    </span>
                  </v-banner>
                  <v-btn
                    :loading="calculating"
                    dark
                    color="success"
                    @click="tryCalculate()"
                  >
                    {{ $t("globals.revise") }}
                  </v-btn>
                </v-row>
                <v-row></v-row>
              </v-container>
              <v-card-actions>
                <v-flex>
                  <v-btn
                    :disabled="calculating || calculateColor === 'success'"
                    text
                    @click="dialog = true"
                  >
                    {{ $t("Cancel") }}
                  </v-btn>
                  <v-btn
                    :disabled="calculating || calculateColor === 'success'"
                    text
                    @click="
                      planParameters.HasStores && planParameters.ReportsPerStore
                        ? (step = 3)
                        : (step = 2)
                    "
                  >
                    {{ $t("globals.back") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="
                      planParameters.HasStores && planParameters.ReportsPerStore
                        ? (step = 5)
                        : (step = 4)
                    "
                    :disabled="calculating || !calculated"
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step
            :complete="
              planParameters.HasStores && planParameters.ReportsPerStore
                ? step > 5
                : step > 4
            "
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 5 : 4
            "
            v-if="planParameters.HasBillingImport"
          >
            {{ $t("views.billingwizard.corporate_stores_billing_import") }}
            <small>
              {{
                $t(
                  "views.billingwizard.download_and_use_a_data_template_in_xlsx_format_optional"
                )
              }}
            </small>
          </v-stepper-step>

          <v-stepper-content
            :step="
              planParameters.HasStores && planParameters.ReportsPerStore ? 5 : 4
            "
            v-if="planParameters.HasBillingImport"
            style="padding-top:0; margin-top:0"
          >
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col class="col-auto">
                    <v-btn
                      :loading="downloading"
                      color="success"
                      @click="downloadTemplate()"
                    >
                      {{ $t("globals.download") }}
                    </v-btn>
                  </v-col>
                  <v-col class="col-auto">
                    <v-dialog v-model="validationTipsDialog" width="500">
                      <template v-slot:activator="{ on }">
                        <v-btn color="success" dark v-on="on">
                          {{ $t("components.membersimportwizardcomponent.validation_rules") }}
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title
                          style="background:#4caf50;color: white;"
                          class="headline lighten-2"
                          primary-title
                        >
                          {{ $t("components.membersimportwizardcomponent.validation_rules") }}
                        </v-card-title>
                        <v-card-text>
                          <div style="padding-top:5px"></div>
                          <strong>
                            {{
                              $t(
                                "components.membersimportwizardcomponent.dates"
                              )
                            }}:
                          </strong>
                          {{
                            $t(
                              "components.membersimportwizardcomponent.columns_that_contain_date_values_must_have_their_format_cell"
                            )
                          }}
                          <v-divider />
                          <strong>
                            {{
                              $t(
                                "components.membersimportwizardcomponent.currency_format"
                              )
                            }}:
                          </strong>
                          {{
                            $t(
                              "components.membersimportwizardcomponent.currency_format_example"
                            )
                          }}
                          <v-divider />
                          <strong>
                            {{
                              $t(
                                "components.membersimportwizardcomponent.selection_columns"
                              )
                            }}:
                          </strong>
                          {{
                            $t(
                              "components.membersimportwizardcomponent.those_columns_should_contain_values_that_are_valid_names_eg"
                            )
                          }}
                          <v-divider />
                          <strong>
                            {{
                              $t(
                                "components.membersimportwizardcomponent.multi_select_columns"
                              )
                            }}:
                          </strong>
                          {{
                            $t(
                              "components.membersimportwizardcomponent.if_multiple_values_are_to_be_added_they_need_to"
                            )
                          }}
                          <v-divider />
                          <div v-if="mHeaders">
                            <strong>
                              {{
                                $t(
                                  "components.membersimportwizardcomponent.required_columns"
                                )
                              }}:
                            </strong>
                            <span>
                              {{
                                mHeaders
                                  .filter(
                                    (f) => !f.isOptional && f.usedInBulkImport
                                  )
                                  .map((f) =>
                                    $t("headers.members_wizard." + f.text)
                                  )
                                  .join(", ")
                              }}
                            </span>
                            <v-divider />
                            <strong>
                              {{
                                $t(
                                  "components.membersimportwizardcomponent.optional_columns"
                                )
                              }}:
                            </strong>
                            <span>
                              {{
                                mHeaders
                                  .filter(
                                    (f) => f.isOptional && f.usedInBulkImport
                                  )
                                  .map((f) =>
                                    $t("headers.members_wizard." + f.text)
                                  )
                                  .join(", ")
                              }}
                            </span>
                          </div>
                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                          <div class="flex-grow-1"></div>
                          <v-btn
                            color="primary"
                            text
                            @click="validationTipsDialog = false"
                          >
                            {{ $t("globals.close") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-text>
                <div>
                  <small>
                    {{
                      $t(
                        "Choose the file to import data from using the select file form below. Accepted format is xls, xlsx. Your data will be validated based on the requirements and restrictions of the data fields type and format rules."
                      )
                    }}
                  </small>
                </div>
                <file-uploader
                  v-show="!confirmed"
                  ref="uploader"
                  label="Select xls or xlsx file"
                  accept=".xlsx, .xls"
                  :uploading="uploading"
                  :url="apiURL"
                  v-on:upload-started="onUploadStarted"
                  v-on:upload-error="onUploadError"
                  v-on:upload-completed="onUploadCompleted"
                ></file-uploader>
                <span v-if="uploading">
                  {{ $t("components.membersimportwizardcomponent.please_wait") }}
                </span>
                <div v-if="uploaded && uploadedOK">
                  <v-banner
                    icon="done"
                    color="success"
                    elevation="0"
                    icon-color="white"
                  >
                    {{ $t(uploadResult) }}
                  </v-banner>
                  <v-container fluid>
                    <v-row>
                      <v-col>
                        <v-form v-model="valid">
                          <v-list>
                            <v-subheader>Required</v-subheader>
                            <v-container fluid>
                              <v-row>
                                <v-col
                                  xs="12"
                                  sm="6"
                                  md="4"
                                  lg="3"
                                  v-for="item in requiredColumns"
                                  :key="item"
                                >
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-text="item"
                                      ></v-list-item-title>
                                      <v-select
                                        v-model="columnsAssociations[item]"
                                        :items="detectedColumns"
                                        :label="
                                          $t('components.membersimportwizardcomponent.detected')
                                        "
                                        :rules="[$rules.required]"
                                        class="required"
                                      ></v-select>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-container>
                            <v-divider></v-divider>

                            <v-subheader>Optional</v-subheader>
                            <v-container fluid>
                              <v-row>
                                <v-col
                                  xs="12"
                                  sm="6"
                                  md="4"
                                  lg="3"
                                  v-for="item in optionalColumns"
                                  :key="item"
                                >
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-text="item"
                                      ></v-list-item-title>

                                      <v-select
                                        clearable
                                        v-model="columnsAssociations[item]"
                                        :items="detectedColumns"
                                        :label="
                                          $t('components.membersimportwizardcomponent.detected')
                                        "
                                      ></v-select>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-list>
                        </v-form>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn
                          color="primary"
                          @click="confirmMatch()"
                          :disabled="!valid || confirmed"
                          :loading="loading"
                        >
                          {{ $t("components.membersimportwizardcomponent.confirm_match") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <div v-if="confirmed">
                          <v-banner
                            icon="done"
                            color="success"
                            elevation="0"
                            icon-color="white"
                          >
                            {{ $t("globals.success") }}
                          </v-banner>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <template v-for="(error, i) in errors">
                          <v-alert dense type="error" :key="i" dismissible>
                            {{ $t(error) }}
                          </v-alert>
                        </template>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <template v-for="(error, i) in uploadErrors">
                  <v-alert dense type="error" :key="i" dismissible>
                    {{ $t(error) }}
                  </v-alert>
                </template>
              </v-card-text>
              <v-card-actions>
                <v-flex>
                  <v-btn :disabled="uploading" text @click="dialog = true">
                    {{ $t("Cancel") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="
                      planParameters.HasStores && planParameters.ReportsPerStore
                        ? (step = 6)
                        : (step = 5)
                    "
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step
            :complete="
              planParameters.HasStores &&
              planParameters.ReportsPerStore &&
              planParameters.HasBillingImport
                ? step > 6
                : planParameters.HasStores &&
                  planParameters.ReportsPerStore &&
                  !planParameters.HasBillingImport
                ? step > 5
                : step > 4
            "
            :step="
              planParameters.HasStores &&
              planParameters.ReportsPerStore &&
              planParameters.HasBillingImport
                ? 6
                : planParameters.HasStores &&
                  planParameters.ReportsPerStore &&
                  !planParameters.HasBillingImport
                ? 5
                : 4
            "
          >
            {{
              term != null
                ? $t(
                    "views.billingwizard.premiums_&_billing_calculation_reports_for_{0}_for_plan_{1}",
                    [trans(term, "Name"), trans(selectedPlan, "Name")]
                  )
                : $t(
                    "views.revisewizard.premiums_&_billing__revised_calculation_reports"
                  )
            }}
            <small>
              {{
                $t(
                  "views.billingwizard.navigate_to_the_produced_calculation_results_and_handle_the_reports"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content
            :step="
              planParameters.HasStores &&
              planParameters.ReportsPerStore &&
              planParameters.HasBillingImport
                ? 6
                : planParameters.HasStores &&
                  planParameters.ReportsPerStore &&
                  !planParameters.HasBillingImport
                ? 5
                : 4
            "
          >
            <v-card>
              <v-card-text>
                <get-reports
                  ref="getReports"
                  v-if="calculated === true && step > 3"
                  :term="term"
                  :reportId="reportId"
                ></get-reports>
              </v-card-text>
              <v-card-actions>
                <v-flex>
                  <v-btn text @click="dialog = true">
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn color="primary" @click="finish()">
                    {{ $t("globals.finish") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </material-card>
    </div>
    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import FileUploader from "../components/FileUploader";
import GetReports from "../components/GetReports";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import { translate2 } from "../trans2";
import { locker } from "../mixins/locker";
import MembersManagementTable from "../components/MembersManagementTable";
import { ODataHeader, ODataInteger, ODataString } from "pbas-vue-components";
import { planSetter } from "../mixins/planSetter";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "revise-wizard",
  components: {
    GetReports,
    ErrorHandler,
    FileUploader,
    MembersManagementTable,
  },
  mixins: [locker, planSetter],
  data() {
    return {
      storeType: null,
      storeTypes: [
        { Id: 1, Name: this.$t("views.revisewizard.corporate_stores") },
        { Id: 2, Name: this.$t("views.revisewizard.franchise_stores") },
        { Id: 3, Name: this.$t("globals.employer") },
      ],
      reportId: null,
      selectedStores: null,
      stores: [],
      membersProvider: undefined,
      membersForTerm: false,
      members: false,
      membersForTermHeaders: null,
      mHeaders: null,
      storesReports: [],
      selectedStoresReports: [],
      employersReports: [],
      selectedEmployersReports: [],
      storeValid: true,
      term: null,
      billingTerms: [],
      loaded: false,
      valid: true,
      guid: null,
      columnsAssociations: {},
      requiredColumns: [],
      optionalColumns: [],
      detectedColumns: [],
      confirmed: false,
      membersAdded: [],
      membersUpdated: [],
      uploadErrors: [],
      errors: [],
      validationTipsDialog: false,
      apiURL: null,
      uploaded: false,
      uploading: false,
      uploadedOK: false,
      downloading: false,
      error: null,
      calculateMessage: "",
      calculateIcon: "",
      calculateColor: "",
      loading: false,
      calculated: false,
      calculating: false,
      saving: false,
      csvOptions: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
      dialog: false,
      step: 0,
    };
  },
  computed: {
    ...mapGetters("plansMembers", { planParameters: "planOptions" }),
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
    reportOptions: function() {
      var reportOptions = [];
      if (this.planParameters.HasPremiums) {
        reportOptions.push("Premiums");
      }
      if (this.planParameters.HasCommissions) {
        reportOptions.push("Commissions");
      }
      if (this.planParameters.HasBilling) {
        reportOptions.push("Billing");
      }
      if (this.planParameters.HasRemittances) {
        reportOptions.push("Remittances");
      }
      return reportOptions;
    },
    membersForTermOdata: function() {
      return {
        url:
          "plans/" + this.selectedPlan.Id + "/membersForTerm/" + this.term.Id,
      };
    },
    successMessage: function() {
      return this.$t("views.billingwizard.calculation_succeeded");
    },
    failMessage: function() {
      return this.$t("views.billingwizard.calculation_failed");
    },
  },
  watch: {
    storeType: {
      async handler(v) {
        switch (v.Id) {
          case 1: {
            try {
              this.stores = (await this.getStoresWithFilter({
                plan: this.selectedPlan.Id,
                filter: "$filter=IsAssignable ne true",
              })).data.value;
              //console.log(this.stores);
            } catch (error) {
              this.error = error;
            }
            break;
          }
          case 2: {
            try {
              this.stores = (await this.getStoresWithFilter({
                plan: this.selectedPlan.Id,
                filter: "$filter=IsAssignable eq true",
              })).data.value;
              //console.log(this.stores);
            } catch (error) {
              this.error = error;
            }
            break;
          }
          case 3: {
            try {
              this.selectedStores = (await this.getStoresWithFilter({
                plan: this.selectedPlan.Id,
                filter: "$filter=IsAssignable eq true",
              })).data.value;
              //console.log(this.stores);
            } catch (error) {
              this.error = error;
            }
            break;
          }
          default:
            break;
        }
      },
    },
    step: {
      async handler(v) {
        //console.log("step: ", v);
        switch (v) {
          case 1: {
            if (
              this.planParameters.HasStores &&
              this.planParameters.ReportsPerStore
            ) {
              this.initStoresStep();
            } else {
              this.initMembersStep();
            }
            break;
          }
          case 2: {
            if (
              this.planParameters.HasStores &&
              this.planParameters.ReportsPerStore
            ) {
              this.initMembersStep();
            } else {
              await this.initMembersForTermStep();
            }
            break;
          }
          case 3: {
            if (
              this.planParameters.HasStores &&
              this.planParameters.ReportsPerStore
            ) {
              await this.initMembersForTermStep();
            } else {
              this.initAdjStep();
            }
            break;
          }
          case 4: {
            if (
              this.planParameters.HasStores &&
              this.planParameters.ReportsPerStore
            ) {
              this.initAdjStep();
            } else {
              if (!this.planParameters.HasBillingImport) {
                this.initReportStep();
              }
            }
            break;
          }
          case 5: {
            if (
              this.planParameters.HasStores &&
              this.planParameters.ReportsPerStore
            ) {
              if (!this.planParameters.HasBillingImport) {
                this.initReportStep();
              }
            } else {
              this.initReportStep();
            }
            break;
          }
          case 6: {
            if (
              this.planParameters.HasStores &&
              this.planParameters.ReportsPerStore
            ) {
              this.initReportStep();
            }
            break;
          }
        }
      },
    },
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "postConfirmMatchBilling",
      "getBlobAsync",
      "getCompletedBillingTerms",
      "getEmployersReports",
      "getStoresReports",
      "getCurrentTermForRevise",
      "getMembersBillingWizardColumns",
      "getStores",
      "getStoresWithFilter",
    ]),
    ...mapActions("common", ["createOdataType"]),
    ...mapActions("transactions", ["calculateRevise"]),
    async loadPlanData() {
      try {
        // console.log(
        //   "revise mounted",
        //   this.planParameters.HasStores && this.planParameters.ReportsPerStore
        // );
        this.term = await this.lock(
          this.getCurrentTermForRevise,
          this.selectedPlan.Id,
          () => {
            this.$router.push({ name: "billing", params: { planId: this.selectedPlan.Id } });
          }
        );
      } catch (error) {
        this.error = error;

        setTimeout(() => {
          this.$router.push({ name: "billing", params: { planId: this.selectedPlan.Id } });
        }, 2500);
      }
      try {
        //console.log(this.term);

        let mHeaders = (await this.getMembersBillingWizardColumns(
          this.selectedPlan.Id
        )).data
          .filter((o) => o.showOnExpandOnly !== true)
          .sort((a, b) => {
            return a.order - b.order;
          });
        this.membersForTermHeaders = this.$helpers.createOdataHeaders(mHeaders);

        this.apiURL =
          this.settings.APIURL +
          "plans/" +
          this.selectedPlan.Id +
          "/billing-import";
        this.mHeaders = mHeaders;

        this.step = 1;

        //console.log("$$$$$$$$$$$", this.step);
      } catch (error) {
        this.error = error;
      }
    },
    initAdjStep() {
      this.calculateMessage = "";
      this.calculateColor = "";
      this.$forceUpdate();
    },
    async initStoresStep() {
      if (!this.planParameters.HasBillingImport) {
        try {
          this.stores = (await this.getStores(this.selectedPlan.Id)).data.value;
        } catch (error) {
          this.error = error;
        }
      }
    },
    initMembersStep() {
      this.$refs.membersTable.getDataAsync();
    },
    async initMembersForTermStep() {
      this.loaded = false;
      if (this.membersProvider) {
        this.$refs.membersForTermTable.getDataAsync();
      } else {
        this.membersProvider = new PbasOData(
          this.$axiosHttp,
          this.membersForTermOdata.url,
          this.membersForTermHeaders
        );
      }
    },
    initReportStep() {
      this.unlock();
      this.$nextTick(() => {
        this.$refs.getReports.reset();
      });
    },
    trans(item, field) {
      return translate2(item, field);
    },
    setMembersForTerm(items) {
      this.membersForTerm = items && items.length > 0;
      this.loaded = true;
    },
    async confirmMatch() {
      try {
        this.loading = true;
        //const url = "http://localhost:5011/MemberImport/Plan/" + this.selectedPlan.Id + "/Parse/" + this.guid;
        //const res = (await this.postAsync({url: url, payload: this.columnsAssociations})).data;
        let payload = {
          Associations: this.columnsAssociations,
          IsRevised: true,
        };
        if (
          this.planParameters.HasStores &&
          this.planParameters.ReportsPerStore &&
          this.storeType !== 3
        ) {
          payload.StoreIds = this.selectedStores.map((o) => o.Id);
        }
        const res = (await this.postConfirmMatchBilling({
          guid: this.guid,
          plan: this.selectedPlan.Id,
          payload: payload,
        })).data;
        this.membersAdded = res.membersAdded;
        this.membersUpdated = res.membersUpdated;
        this.confirmed = true;
      } catch (error) {
        if (error.response) this.errors = error.response.data;
        else this.error = error;
      }
      this.loading = false;
    },
    onUploadStarted() {
      this.uploaded = false;
      this.uploading = true;
    },
    onUploadCompleted(res) {
      this.uploaded = true;
      this.uploadedOK = true;
      this.uploading = false;
      /*this.uploadResult =
        "Upload successful. The uploaded data were successfully imported. Note that during the process " +
        res.data.membersAdded +
        " new members were created. Navigate to members records table to review the updated members data.";*/
      //console.log(res);
      this.requiredColumns = res.data.required;
      this.optionalColumns = res.data.optional;
      this.detectedColumns = res.data.detected;
      this.columnsAssociations = res.data.associations;
      this.guid = res.data.guid;
      this.uploadResult = "views.revise_wizard.upload_result";
    },
    onUploadError(err) {
      //console.log("ERR");
      //console.log(JSON.stringify(err));
      this.uploaded = true;
      this.uploadedOK = false;
      this.uploading = false;
      this.uploadErrors = err.response.data;
    },
    formatErrors(errors) {
      var formattedErrors = {};
      if (errors) {
        errors.forEach((e) => {
          e.Errors.forEach(function(errStr) {
            if (formattedErrors[errStr] != null) {
              formattedErrors[errStr].push(e.Line);
            } else {
              formattedErrors[errStr] = [e.Line];
            }
          });
        });
        return formattedErrors;
      }
    },
    reset() {
      this.$refs.uploader.reset();
      this.step = 3;
      this.uploaded = false;
      this.uploadedOK = false;
      this.uploadResult = "";
      this.confirmed = false;
      this.uploadErrors = [];
      this.errors = [];
    },
    async downloadTemplate() {
      this.downloading = true;
      const url = "plans/" + this.selectedPlan.Id + "/billing-import";

      const filename = "Template.xlsx";
      try {
        let blob = (await this.getBlobAsync({ url: url }))
          .data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);
      } catch (error) {
        this.error = error;
      }

      this.downloading = false;
    },
    finish() {
      /*this.step = 1;
      this.calculateMessage = "";
      this.calculateIcon="";
      this.calculateColor=success;*/
      this.$router.push({ name: "billing", params: { planId: this.selectedPlan.Id } });
    },
    async tryCalculate() {
      this.calculating = true;
      let payload = {
        TermId: this.term.Id,
        StoreIds:
          this.selectedStores !== null && this.selectedStores !== undefined
            ? this.selectedStores.map((o) => o.Id)
            : [],
      };
      // console.log(payload);
      try {
        this.reportId = (await this.calculateRevise({
          plan: this.selectedPlan.Id,
          payload: payload,
        })).data.value;
        this.calculated = true;
        this.calculateMessage = this.successMessage;
        // console.log(this.calculateMessage);
        this.calculateColor = "success";
        this.calculateIcon = "done";
      } catch (error) {
        // console.log(error);
        this.calculateMessage = this.failMessage;
        // console.log(this.calculateMessage);
        this.calculateColor = "error";
        this.calculateIcon = "error_outline";
      }
      this.calculating = false;
    },
    cancel() {
      this.dialog = false;
      /*this.step = 1;
      this.calculateMessage = "";
      this.calculateIcon = "";
      this.calculateColor = "success";
      */
      this.$router.push({ name: "billing", params: { planId: this.selectedPlan.Id } });
    },
  },
};
</script>

<style>
.with-margin {
  margin: 20px;
}
.background-red {
  background-color: red;
}
.background-green {
  background-color: green;
  color: white;
}
.v-stepper small {
  color: rgba(0, 0, 0, 0.54);
}
</style>
